import { ReactElement } from 'react'
import { getStoredPasscode } from '../../utils/passcodeUtils'
import PasscodePrompt from './PasscodePrompt'
import { Stack } from '@mui/material'

function PasscodeChecker({ children }: { children: ReactElement }) {
  const passcode = getStoredPasscode()

  if (passcode == null) {
    return (
      <Stack
        direction="column"
        spacing={1}
        sx={{
          justifyContent: 'space-evenly',
          alignItems: 'center',
          marginTop: 10
        }}
      >
        <PasscodePrompt />
      </Stack>
    )
  }

  return children
}

export default PasscodeChecker
